import "@/styles/components/zoomFullScreen.css";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import { Box, Container, Stack, Zoom } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import _ from "lodash";
import * as React from "react";
import ReactImageMagnify from "react-image-magnify";
import connectConfig from "../config/connectConfig";

//To set ZoomIn Effect
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} timeout={500} />;
});

const ZoomFullScreen = ({
  open,
  handleClose,
  selectedIndex,
  setSelectedIndex,
  attachments,
}) => {
  const selectedImage = `${connectConfig.s3}/${attachments[selectedIndex]}`;
  const imageListWidth = Object.keys(attachments).length * 110;
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        hideBackdrop
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Container className="zoom-parent" maxWidth="100%">
          <Stack sx={{ alignItems: "flex-start" }} direction={"row"}>
            <ZoomPhoto source={selectedImage} />
            <IconButton
              disableRipple
              edge="start"
              sx={{ backgroundColor: "black", color: "white", marginTop: 2 }}
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <ZoomInMapIcon />
            </IconButton>
          </Stack>
        </Container>
        <div
          style={{
            width: "100%",
            position: "fixed",
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ImageList
              cols={Object.keys(attachments).length}
              sx={{ width: imageListWidth, maxWidth: "50%", pl: 1, pr: 1 }}
            >
              {_.map(attachments, (attachment, index) => {
                return (
                  <ImageListItem key={index}>
                    <div
                      onClick={() => setSelectedIndex(index)}
                      className="zoom-in zoom-in-hover"
                      role="img"
                      style={{
                        opacity: selectedIndex === index ? 1 : 0.2,
                        borderRadius: "14px",
                        width: "100px",
                        height: "100px",
                        border: "1px solid white",
                        backgroundImage: `url("${connectConfig.s3}/${attachment}")`,
                        backgroundPosition: "50%",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    />
                  </ImageListItem>
                );
              })}
            </ImageList>
          </Box>
        </div>
      </Dialog>
    </React.Fragment>
  );

  // create a component
  function ZoomPhoto({ source }) {
    const [isFluidWidth, setFluidWidth] = React.useState(true);
    const [bigger20percent, setBigger20percent] = React.useState(false);
    const [dimensions, setDimensions] = React.useState({
      width: "",
      height: "",
    });

    React.useEffect(() => {
      // read final size of image on html dom tree
      const imgClientSize = {
        width: document.querySelector(".zoom").clientWidth,
        height: document.querySelector(".zoom").clientHeight,
      };
      //read size of parent layer of the image
      const parentSizeWidth =
        document.querySelector(".zoom-parent").clientWidth;

      /*
        1. create image Object to store image and read actual width and height 
        2. compare img size with its parent size
      */
      const img = new Image();
      img.src = source;
      img.onload = () =>
        setDimensions({ width: img.width, height: img.height });

      if (imgClientSize.width > parentSizeWidth * 0.3) {
        setFluidWidth(true);
      } else if (imgClientSize.width > parentSizeWidth * 0.2) {
        setFluidWidth(false);
        setBigger20percent(true);
      } else {
        setFluidWidth(false);
        img.height > window.innerHeight
          ? setBigger20percent(true)
          : setBigger20percent(false);
      }
    }, [source]);

    return (
      <div className="fluid">
        <div className="fluid__image-container">
          <ReactImageMagnify
            className="zoom"
            {...{
              smallImage: {
                isFluidWidth: true,
                src: source,
              },
              largeImage: {
                src: source,
                width: parseInt(dimensions.width) * 1.3,
                height: parseInt(dimensions.height) * 1.3,
              },
            }}
          />
        </div>
      </div>
    );
  }
};
export default ZoomFullScreen;
